import { CampaignStatus } from '../../graphql/enums';

/**
 * Returns true if a campaign in the given status can be edited.
 * Only DRAFT campaigns are editable.
 */
export const isEditable = (status: CampaignStatus): boolean => {
  return status === CampaignStatus.Draft;
};

/**
 * Returns true if a campaign in the given status can be deleted.
 * DRAFT and SCHEDULED campaigns can be deleted; SENT campaigns cannot.
 */
export const isDeletable = (status: CampaignStatus): boolean => {
  return status === CampaignStatus.Draft || status === CampaignStatus.Scheduled;
};

/**
 * Resolves the send mode label for a campaign.
 * - If scheduledSendAt is set, returns 'scheduled'.
 * - Otherwise returns 'immediate'.
 */
export const resolveSendMode = (
  scheduledSendAt: string | null | undefined
): 'scheduled' | 'immediate' => {
  return scheduledSendAt ? 'scheduled' : 'immediate';
};
